import { cn } from '@/lib/utils'
import { HtmlHTMLAttributes } from 'react'

export default function Button({
  className,
  ghost,
  full,
  type,
  disable,
  sm,
  ...props
}: HtmlHTMLAttributes<HTMLButtonElement> & {
  ghost?: boolean
  sm?: boolean
  full?: boolean,
  disable?: boolean
  type?:any
}) {
  return (
    <button
    disabled={disable}
    type={type}
      className={cn(
        'whitespace-nowrap rounded-full bg-primary px-16 py-3 text-center font-poppins font-medium  text-white  transition-all hover:bg-primary/80 ',
        {
          'bg-transparent px-5 text-black ring-0 hover:bg-primary/10': ghost,
          ' py-2': sm,
          'w-full px-0': full,
        },
        className
      )}
      {...props}
    />
  )
}
